export default __webpack_public_path__ + "d22d2934e0536de76a1757e52a9e1277.svg";